import { TableLoader } from 'components/table-loader/table-loader';
import { getAccessToken } from 'features/auth';
import { NotificationListener } from 'features/Notifications/NotificationListener';
import {  useUserContext } from 'features/users';
import { useEffect } from 'react';
import { RouterProvider } from "react-router-dom";

import { router } from "./router"; // your routerConfig


function AppRouter() {
    
  const { user } = useUserContext(); // Add a `loading` flag if needed
   
  const token = getAccessToken();

 if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js')
    // .then((registration) => {
    //   //console.log('Service Worker registered:', registration);
    // })
    // .catch((error) => {
    //   //console.error('Service Worker registration failed:', error);
    // });
}   

  useEffect(() => {
    if (user && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }, [user]);

  if (token && !user) {
    return <div
      style={{
        display: "flex",
        justifyContent: "center", // horizontal center
        alignItems: "center",     // vertical center
        height: "100vh",          // full viewport height
      }}
    ><TableLoader /></div>; // or redirect/login page
  }

  return (
  <>


  {user && <NotificationListener user={user}/>}
  <RouterProvider router={router} />
  </>
  );
}

export default AppRouter;